/*
  PrivacyTab — Maxfiylik va hisob bo'limi.

  Nega kerak: Google Play (2023 dan) va Apple App Store (2022 dan)
  foydalanuvchining o'z hisobini o'chirish yo'lini majburiy talab qiladi.
  Talab mobil ilovaga tegishli, lekin veb va mobil bir xil tizim bo'lgani
  uchun bu yerda ham bo'lishi kerak — aks holda veb foydalanuvchisi o'z
  ma'lumotini o'chira olmaydi.

  Nega parol so'raladi: amal ortga qaytarilmaydi, tasodifiy yoki begona
  bosishdan himoya kerak.
*/
import React, { useState } from "react"
import { Card, Button, Modal, Input, Space, Typography, message, Alert } from "antd"
import { Shield, Trash2, ExternalLink } from "react-feather"
import { useTranslation } from "react-i18next"
import { request } from "../../../../utils/config"

const { Text, Paragraph } = Typography

const PRIVACY_URL = "https://crp.zendig.uz/privacy.html"

export default function PrivacyTab() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [password, setPassword] = useState("")
  const [busy, setBusy] = useState(false)

  const cardStyle: React.CSSProperties = { marginBottom: 12, borderRadius: 8 }
  const titleStyle: React.CSSProperties = { fontSize: 13, fontWeight: 600 }

  const handleDelete = async () => {
    if (!password.trim()) return
    setBusy(true)
    try {
      const res: any = await request({
        url: "Users/DeleteMyAccount",
        method: "POST",
        data: { currentPassword: password },
      })
      message.success(res?.data?.Message || t("deleteAccountDone"))
      setOpen(false)
      setPassword("")
      // Hisob yopildi — sessiyani tozalab kirish sahifasiga qaytaramiz
      localStorage.clear()
      window.location.href = "/"
    } catch (e: any) {
      const msg =
        e?.response?.data?.Message ||
        e?.response?.data?.message ||
        t("deleteAccountFailed")
      message.error(String(msg))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div style={{ padding: "4px 0" }}>
      <Card
        size="small"
        title={
          <Space>
            <Shield size={15} color="#0EA5E9" />
            <span style={titleStyle}>{t("privacyPolicy")}</span>
          </Space>
        }
        style={cardStyle}
      >
        <Paragraph style={{ marginBottom: 12, fontSize: 13 }}>
          {t("privacyPolicyDesc")}
        </Paragraph>
        <Button
          icon={<ExternalLink size={14} style={{ marginRight: 6 }} />}
          href={PRIVACY_URL}
          target="_blank"
          rel="noreferrer"
          style={{ borderRadius: 6 }}
        >
          {t("openPrivacy")}
        </Button>
      </Card>

      <Card
        size="small"
        title={
          <Space>
            <Trash2 size={15} color="#EF4444" />
            <span style={titleStyle}>{t("deleteAccount")}</span>
          </Space>
        }
        style={cardStyle}
      >
        <Alert
          type="warning"
          showIcon
          message={t("deleteAccountWarn")}
          style={{ marginBottom: 12, fontSize: 13 }}
        />
        <Button danger onClick={() => setOpen(true)} style={{ borderRadius: 6 }}>
          {t("deleteAccount")}
        </Button>
      </Card>

      <Modal
        visible={open}
        title={t("deleteAccount")}
        onCancel={() => {
          setOpen(false)
          setPassword("")
        }}
        onOk={handleDelete}
        okText={t("deleteAccount")}
        cancelText={t("cancel")}
        okButtonProps={{ danger: true, disabled: !password.trim(), loading: busy }}
        zIndex={1300}
        destroyOnClose
      >
        <Paragraph style={{ fontSize: 13 }}>{t("deleteAccountWarn")}</Paragraph>
        <Text style={{ fontSize: 13 }}>{t("deleteAccountPassword")}</Text>
        <Input.Password
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
          style={{ marginTop: 8, borderRadius: 6 }}
          onPressEnter={handleDelete}
        />
      </Modal>
    </div>
  )
}
